import { usePartner } from '@/providers/Partner';
import Image from 'next/image';
import React from 'react';

export default function LoginLogo() {
    const partner = usePartner();

    return (
        <Image
            src={partner.pages.login.logo.src}
            width={partner.pages.login.logo.width}
            height={partner.pages.login.logo.height}
        />
    );
}
